import {http} from './index';
import {StudentBookingListParams} from '@types';

//通过网校id或者学员ID获取用户私有信息
// export const reqMemberPersonalData = (params: {studentId?: number}) => http.get('/olaf/api/v1/member/personal-data', params);
export const reqMemberPersonalData = (guid:string) => http.get(`/olaf/api/v1/member/personal-data/${guid}`);

//项目科目下学生课程列表
export const reqStudentCourseList = (params: {studentId: number}) => http.get('/teaching-workbench/api/v1/file/course-list', params);

//项目科目下学习数据接口
export const reqStudentStudyData = (params: {studentId: number, projectId: number, subjectId: number}, options?: {}) => http.get('/teaching-workbench/api/v1/file/study-data', params, options);

//学员私教预约记录列表
export const reqStudentBookingList = (params: StudentBookingListParams, options?: {}) => http.get('/olaf/api/v1/booking/student-bookings', params, options);